import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const likesResolver: FieldResolver = (metadata: Metadata) =>
  ({ likes: metadata.getLikes() } as StreamData)

export default likesResolver
